import React, {Component} from 'react';
import ReactQuill from 'react-quill';
import {Popup, Icon, Label, Flag, TextArea} from 'semantic-ui-react';
import {plainTextToQuillHtml} from 'src/components/Table/components/twoLanguage/EditorUtil';

interface IPCCDTextComparePopup {
    item: any;
    t: reactI18Next.TranslationFunction;
    label?: string;
}

class PCCDTextComparePopup extends Component<IPCCDTextComparePopup, any> {
    constructor(props: IPCCDTextComparePopup) {
        super(props);

        this.state = {
            triggerActionType: "click",
        };
    }

    render() {
        const {item, t, label} = this.props;
        const translationLenth = t("OPTION_BASIC_TEXT").split(' ').length;
        const lastWord = t("OPTION_BASIC_TEXT").split(' ')[translationLenth - 1];
        return (
            <Popup
                style={{
                    maxHeight: '500px',
                    overflow: 'inherit'
                }}
                key={item._id}
                className="zIndex-9999"
                position={"top center"}
                onOpen={() => this.setState({triggerActionType: 'hover'})}
                onClose={() => this.setState({triggerActionType: 'click'})}
                on={this.state.triggerActionType}
                trigger={
                    <Icon
                        name={"clone"}
                        disabled={true}
                    />
                }
                flowing={true}
                hoverable={true}
            >
                {/* short text */}
                <div className='display--flex flex-direction--column'>
                    <Label
                        style={{textAlign: 'center'}}
                        basic={true}
                        className="textCompareBlockLabel"
                        content={t("COLUMN_FACTORY:SHORTTEXT")}
                    />
                    <div className='display--flex'>
                        {/* option text short de */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={label ? label : t("GLOBAL:OPTION_TEXT")}
                                icon={<Flag name={item.shorttext.length > 0 && item.shorttext[0].flag} />}
                            />
                            <TextArea
                                className="textCompareTextArea"
                                fluid="true"
                                disabled={true}
                                value={item.shorttext.length > 0 ? item.shorttext[0].value : ''}
                            />
                        </div>
                        {/* pccd text short  de */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={`PCCD ${lastWord}`}
                                icon={<Flag name='de' />}
                            />
                            <TextArea
                                className="textCompareTextArea"
                                fluid="true"
                                disabled={true}
                                value={item.shortPCCDtext[0] !== undefined ? item.shortPCCDtext[0].value : ''}
                            />
                        </div>
                    </div>
                    <div className='display--flex'>
                        {/* optin text short gb */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={label ? label : t("GLOBAL:OPTION_TEXT")}
                                icon={<Flag name={item.shorttext.length > 1 && item.shorttext[1].flag} />}
                            />
                            <TextArea
                                className="textCompareTextArea"
                                fluid="true"
                                disabled={true}
                                value={item.shorttext.length > 1 ? item.shorttext[1].value : ''}
                            />
                        </div>
                        {/* pccd text short gb */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={`PCCD ${lastWord}`}
                                icon={<Flag name='gb' />}
                            />
                            <TextArea
                                className="textCompareTextArea"
                                fluid="true"
                                disabled={true}
                                value={item.shortPCCDtext[1] !== undefined ? item.shortPCCDtext[1].value : ''}
                            />
                        </div>
                    </div>
                </div>
                <br />
                {/* long text */}
                <div className='display--flex flex-direction--column'>
                    <Label
                        style={{textAlign: 'center'}}
                        basic={true}
                        className="textCompareBlockLabel"
                        content={t("COLUMN_FACTORY:LONGTEXT")}
                    />
                    <div className='display--flex'>
                        {/* option long text de */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={label ? label : t("GLOBAL:OPTION_TEXT")}
                                icon={<Flag name={item.longtext.length > 0 && item.longtext[0].flag} />}
                            />
                            <ReactQuill
                                className="textCompareTextArea"
                                modules={{toolbar: false}} // Hide toolbar
                                readOnly={true} // Make ReactQuill read-only
                                value={!/^<.*?>.*<\/.*?>$/.test(item.longtext.length > 0 && item.longtext[0].value)
                                    ? plainTextToQuillHtml(item.longtext.length > 0 && item.longtext[0].value)
                                    : item.longtext.length > 0 && item.longtext[0].value}
                            />
                        </div>
                        {/* pccd long text de */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={`PCCD ${lastWord}`}
                                icon={<Flag name={item.longtext.length > 0 && item.longtext[0].flag} />}
                            />
                            <ReactQuill
                                className="textCompareTextArea"
                                modules={{toolbar: false}} // Hide toolbar
                                readOnly={true} // Make ReactQuill read-only
                                value={!/^<.*?>.*<\/.*?>$/.test(item.longPCCDtext[0] !== undefined ? item.longPCCDtext[0].value : '')
                                    ? plainTextToQuillHtml(item.longPCCDtext[0] !== undefined ? item.longPCCDtext[0].value : '')
                                    : item.longPCCDtext[0] !== undefined ? item.longPCCDtext[0].value : ''}
                            />
                        </div>
                    </div>
                    <div className='display--flex'>
                        {/* otion text long gb */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={label ? label : t("GLOBAL:OPTION_TEXT")}
                                icon={<Flag name={item.longtext.length > 1 && item.longtext[1].flag} />}
                            />
                            <ReactQuill
                                className="textCompareTextArea"
                                modules={{toolbar: false}} // Hide toolbar
                                readOnly={true} // Make ReactQuill read-only
                                value={!/^<.*?>.*<\/.*?>$/.test(item.longtext.length > 1 && item.longtext[1].value)
                                    ? plainTextToQuillHtml(item.longtext.length > 1 && item.longtext[1].value)
                                    : item.longtext.length > 1 && item.longtext[1].value}
                            />
                        </div>
                        {/* pccd text long gb */}
                        <div className="textCompareBlock">
                            <Label
                                basic={true}
                                className="textCompareBlockLabel"
                                content={`PCCD ${lastWord}`}
                                icon={<Flag name='gb' />}
                            />
                            <ReactQuill
                                className="textCompareTextArea"
                                modules={{toolbar: false}} // Hide toolbar
                                readOnly={true} // Make ReactQuill read-only
                                value={!/^<.*?>.*<\/.*?>$/.test(item.longPCCDtext[1] !== undefined ? item.longPCCDtext[1].value : '')
                                    ? plainTextToQuillHtml(item.longPCCDtext[1] !== undefined ? item.longPCCDtext[1].value : '')
                                    : item.longPCCDtext[1] !== undefined ? item.longPCCDtext[1].value : ''}
                            />
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export default PCCDTextComparePopup;



// WEBPACK FOOTER //
// ./src/views/OptionsView/PCCDTextComparePopup.tsx